<template>
  <div class="essay-submission-container-pc" v-if="!isMobile">
    <div style="padding-top: 0.1px">
      <!-- ======= Header ======= -->
      <main class="content">
        <div class="place">
          <a @click="$router.push({name: 'home'})">{{ isCN ? "首页" : "Home" }}</a>
          <a>></a>
          <a>{{ isCN ? "征文投稿" : "Call For Abstracts" }}</a>
        </div>
        <div>
          <div class="title">
            <div>{{ isCN ? "征文投稿" : "Call For Abstracts" }}</div>
            <div class="bottom-sol">
              <div></div>
            </div>
          </div>
          <div class="child-content">
            <div class="header">
              <div>
                <strong>{{ isCN ? "征文通知" : "Paper Submission Notice" }}</strong>
              </div>
            </div>
            <div class="child-child-content">
              <div class="desc" style="display: none;">
                <div>
                  <span>2026年4月13日至19日，一年一度的CHINA VALVE（HANGZHOU）2026</span>
                  将在杭州如期举办。本次大会目前已开始论文征集及评选，诚邀您登陆官网：www.china-valve.org.cn 踊跃投稿。
                </div>
              </div>
              <div class="child-child-table">
                <div class="table-desc">
                  {{ isCN ? "本次大会征文内容包括：" : "Submission Categories" }}
                </div>
                <table class="table table-striped table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">{{ isCN ? "序号" : "Number" }}</th>
                      <th scope="col">{{ isCN ? "论文方向" : "Direction of the paper" }}</th>
                      <th scope="col">{{ isCN ? "序号" : "Number" }}</th>
                      <th scope="col">{{ isCN ? "论文方向" : "Direction of the paper" }}</th>
                    </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>{{ isCN ? "结构性心脏病领域的临床研究" : "Clinical Research in Structural Heart Disease" }}</td>
                    <th scope="row">4</th>
                    <td>{{ isCN ? "结构性心脏病交叉学科研究" : "Interdisciplinary Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>{{ isCN ? "结构性心脏病领域基础研究" : "Basic Research in Structural Heart Disease" }}</td>
                    <th scope="row">5</th>
                    <td>{{ isCN ? "结构性心脏病领域麻醉相关研究" : "Anesthesia-Related Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>{{ isCN ? "结构性心脏病影像研究" : "Imaging Research in Structural Heart Disease" }}</td>
                    <th scope="row">6</th>
                    <td>{{ isCN ? "结构性心脏病领域护理相关研究" : "Nursing-Related Research in Structural Heart Disease" }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="submission-demand">
                <div>
                  {{ isCN ? "征文要求" : "Requirements" }}
                </div>
                <div>
                  {{ isCN ? "1、符合上述征文内容尚未公开发表的论文，以论文全文或论文摘要的形式投稿。" : "1. Submit your abstracts of original research." }}
                </div>
                <div>
                  {{ isCN ? "2、摘要应包括题目、作者、单位、目的、方法、结果及结论，字数500-800字，不含图表。" : "2. Abstract Content: The abstract should include the title, author(s), affiliation, purpose, methods, results, and conclusions. The word count should be between 500-800 words (excluding charts and graphs)." }}
                </div>
                <div>
                  <template v-if="isCN">3、所有征集的有效论文都会由专家评审组统一评审后，择优评选出优秀论文奖，邀请至大会现场进行汇报，<span style="color: #f00;">并推荐至JACC、JACC:Asia杂志</span>。</template>
                  <template v-else>3. All valid submissions will be reviewed by an expert panel. Outstanding papers will be invited to present at the conference and recommended for publication in <span style="color: #f00;">JACC or JACC: Asia</span>.</template>
                </div>
              </div>
              <div class="submission-way">
                <div>
                  {{ isCN ? "投稿方式" : "Submission method" }}
                </div>
                <div>
                  <template v-if="isCN">为了方便投稿、修改以及第一时间了解您稿件的接收和安排情况，会议只接收互联网在线投稿，不接收电子邮件或纸质投稿。请登录会议的专用网站（ <a href="http://www.china-valve.org.cn">http://www.china-valve.org.cn</a>），并点击导航栏中的“<span style="font-weight: bold">征文投稿</span>”，了解投稿要求、程序和细节。</template>
                  <template v-else>In order to facilitate submission, revision, and the first time to understand the receipt and arrangement of your manuscript, the conference only accepts online submission, not E-mail or paper submission. Please visit the conference web site (<a href="http://www.china-valve.org.cn">http://www.china-valve.org.cn</a>), Click "<span style="font-weight: bold">Submit</span>" in the navigation bar to understand the submission requirements, procedures and details.</template>
                </div>
                <div style="font-weight: bold" v-if="isCN">
                  开放时间：2025年12月1日
                </div>
               <div style="font-weight: bold" v-if="isCN">
                  截至时间：2026年2月27日 17:00
               </div>
              <div style="font-weight: bold" v-if="!isCN">
                Submit your abstract
              </div>
              <div style="font-weight: bold" v-if="!isCN">
                Submission opens: December 1, 2025
              </div>
              <div style="font-weight: bold" v-if="!isCN">
                Submission ends: February 26, 2026, 17:00
              </div>
              </div>
              <div class="submission-concat">
                <div style="font-weight: bold">
                  {{ isCN ? "投稿咨询：" : "Contact Information" }}
                  <div>
                    {{ isCN ? "基础研究：胡王兴，" : "Basic Research: Wangxing Hu, Tel: " }}+86 19521572835
                  </div>
                  <div>
                    {{ isCN ? "临床研究：范嘉祺，" : "Clinical Research: Jiaqi Fan, Tel: " }}+86 15267029492
                  </div>
                  <div>
                    {{ isCN ? "技术支持：杨  工，" : "Technical Support: Mr Yang, Tel: " }}+86 13237186198
                  </div>
                </div>
                <div style="font-weight: bold">
                  {{ isCN ? "邮箱：" : "Email: " }}cvh2026@china-valve.org.cn
                </div>
              </div>
              <div class="submission-submit">
<!--                <button style="width: 200px" type="button" class="btn btn-primary btn-lg" @click="submitHandle">{{ isCN ? "点击投稿" : "Submit" }}</button>-->
                <button type="button" class="btn btn-primary btn-lg" disabled>{{ isCN ? "投稿已结束" : "Submissions Closed" }}</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  <div v-else class="essay-submission-container-mobile">
    <div style="padding-top: 0.1px">
      <main class="content">
        <div class="place">
          <a @click="$router.push({name: 'home'})">{{ isCN ? "首页" : "Home" }}</a>
          <a>></a>
          <a>{{ isCN ? "征文投稿" : "Call For Abstracts" }}</a>
        </div>
        <div>
          <div class="title">
            <div>{{ isCN ? "征文投稿" : "Call For Abstracts" }}</div>
            <div class="bottom-sol">
              <div></div>
            </div>
          </div>
          <div class="child-content">
            <div class="header">
              <div>
                <strong>{{ isCN ? "征文通知" : "Paper Submission Notice" }}</strong>
              </div>
            </div>
            <div class="child-child-content">
              <div class="desc" style="display: none;">
                <div>
                  <span>2026年4月13日至19日，一年一度的CHINA VALVE（HANGZHOU）2026</span>
                  将在杭州如期举办。本次大会目前已开始论文征集及评选，诚邀您登陆官网：www.china-valve.org.cn 踊跃投稿。
                </div>
              </div>
              <div class="child-child-table">
                <div class="table-desc">
                  {{ isCN ? "本次大会征文内容包括：" : "Submission Categories" }}
                </div>
                <table class="table table-striped table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{ isCN ? "序号" : "Number" }}</th>
                    <th scope="col">{{ isCN ? "论文方向" : "Direction of the paper" }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>{{ isCN ? "结构性心脏病领域的临床研究" : "Clinical Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>{{ isCN ? "结构性心脏病领域基础研究" : "Basic Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>{{ isCN ? "结构性心脏病影像研究" : "Imaging Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>{{ isCN ? "结构性心脏病交叉学科研究" : "Interdisciplinary Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">5</th>
                    <td>{{ isCN ? "结构性心脏病领域麻醉相关研究" : "Anesthesia-Related Research in Structural Heart Disease" }}</td>
                  </tr>
                  <tr>
                    <th scope="row">6</th>
                    <td>{{ isCN ? "结构性心脏病领域护理相关研究" : "Nursing-Related Research in Structural Heart Disease" }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="submission-demand">
                <div>
                  {{ isCN ? "征文要求" : "Requirements" }}
                </div>
                <div>
                  {{ isCN ? "1、符合上述征文内容尚未公开发表的论文，以论文全文或论文摘要的形式投稿。" : "1. Submit your abstracts of original research." }}
                </div>
                <div>
                  {{ isCN ? "2、摘要应包括题目、作者、单位、目的、方法、结果及结论，字数500-800字，不含图表。" : "2. Abstract Content: The abstract should include the title, author(s), affiliation, purpose, methods, results, and conclusions. The word count should be between 500-800 words (excluding charts and graphs)." }}
                </div>
                <div>
                  <template v-if="isCN">3、所有征集的有效论文都会由专家评审组统一评审后，择优评选出优秀论文奖，邀请至大会现场进行汇报，<span style="color: #f00;">并推荐至JACC、JACC:Asia杂志</span>。</template>
                  <template v-else>3. All valid submissions will be reviewed by an expert panel. Outstanding papers will be invited to present at the conference and recommended for publication in <span style="color: #f00;">JACC or JACC: Asia</span>.</template>
                </div>

              </div>
              <div class="submission-way">
                <div>
                  {{ isCN ? "投稿方式" : "Submission method" }}
                </div>
                <div>
                  <template v-if="isCN">为了方便投稿、修改以及第一时间了解您稿件的接收和安排情况，会议只接收互联网在线投稿，不接收电子邮件或纸质投稿。请登录会议的专用网站（ <a href="http://www.china-valve.org.cn">http://www.china-valve.org.cn</a>），并点击导航栏中的“<span style="font-weight: bold">征文投稿</span>”，了解投稿要求、程序和细节。</template>
                  <template v-else>In order to facilitate submission, revision, and the first time to understand the receipt and arrangement of your manuscript, the conference only accepts online submission, not E-mail or paper submission. Please visit the conference web site (<a href="http://www.china-valve.org.cn">http://www.china-valve.org.cn</a>), Click "<span style="font-weight: bold">Submit</span>" in the navigation bar to understand the submission requirements, procedures and details.</template>
                </div>
                <div style="font-weight: bold" v-if="isCN">
                  开放时间：2025年12月1日
                </div>
               <div style="font-weight: bold" v-if="isCN">
                  截至时间：2026年2月27日 17:00
                </div>
                <div style="font-weight: bold" v-if="!isCN">
                  Submit your abstract
                </div>
                <div style="font-weight: bold" v-if="!isCN">
                  Submission opens: December 1, 2025
                </div>
                <div style="font-weight: bold" v-if="!isCN">
                  Submission ends: February 27, 2026, 17:00
                </div>
              </div>
              <div class="submission-concat">
                <div style="font-weight: bold">
                  {{ isCN ? "投稿咨询：" : "Contact Information" }}
                  <div>
                    {{ isCN ? "基础研究：胡王兴，" : "Basic Research: Wangxing Hu, Tel: " }}+86 19521572835
                  </div>
                  <div>
                    {{ isCN ? "临床研究：范嘉祺，" : "Clinical Research: Jiaqi Fan, Tel: " }}+86 15267029492
                  </div>
                  <div>
                    {{ isCN ? "技术支持：杨  工，" : "Technical Support: Mr Yang, Tel: " }}+86 13237186198
                  </div>
                </div>
                <div style="font-weight: bold">
                  {{ isCN ? "邮箱：" : "e-mail:" }}cvh2026@china-valve.org.cn
                </div>
              </div>
              <div class="submission-submit">
<!--                <button style="width: 200px" type="button" class="btn btn-primary" @click="submitHandle">{{ isCN ? "点击投稿" : "Submit" }}</button>-->
                <button style="width: 200px" type="button" class="btn btn-primary" disabled>{{ isCN ? "投稿已结束" : "Submissions Closed" }}</button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import {isMobile, onscroll, selectEl} from "../utils/util";
import "../assets/css/bootstrap-utilities.css";
import {initWeChatForwardConfiguration} from "../utils/weChatForward";

  export default {
    name: "EssaySubmission",
    data() {
      return {
        isMobile: isMobile()
      }
    },
    created() {
      initWeChatForwardConfiguration("CHINA VALVE（HANGZHOU）2026", window.location.href, "", "2026年4月13-19日 中国·杭州")
    },
    methods: {
      init() {
        this.headerFixed();
        // this.backToTopHandle();
        // this.skilsContentHandle();
        // if (!this.isMobile){
        //   this.initSwiper();
        // }
        // this.initAos();
      },
      goPrevious(year) {
        let url = "http://cvh" + year + ".china-valve.org.cn/";
        if (!this.isCN) {
          url += "?language=en";
        }
        window.open(url);
      },
      mobileNavToggle() {
        selectEl("#navbar").classList.toggle("navbar-mobile");
        selectEl(".mobile-nav-toggle").classList.toggle("bi-list");
        selectEl(".mobile-nav-toggle").classList.toggle("bi-x");
      },
      headerFixed() {
        let selectHeader = selectEl("#header");
        if (!selectHeader) {
          setTimeout(() => {
            this.headerFixed();
          }, 100);
          return;
        }
        if (selectHeader) {
          // let headerOffset = selectHeader.offsetTop
          let nextElement = selectHeader.nextElementSibling;
          let headerFixed = null;
          if (this.isMobile) {
            headerFixed = () => {
              selectHeader.classList.add("fixed-top");
              nextElement.classList.add("scrolled-offset");
              // selectHeader.classList.remove('fixed-top')
              // nextElement.classList.remove('scrolled-offset')
            };
          } else {
            headerFixed = () => {
              if (window.scrollY >= 16) {
                selectHeader.classList.add("fixed-top");
                nextElement.classList.add("scrolled-offset");
              } else {
                selectHeader.classList.remove("fixed-top");
                nextElement.classList.remove("scrolled-offset");
              }
            };
          }
          window.addEventListener("load", headerFixed);
          onscroll(document, headerFixed);
        }
      },
      dropdownHandle() {
        selectEl(".huigu").classList.toggle("dropdown-active");
      },
      submitHandle() {
        const url = this.isCN?'https://faculty.china-valve.org.cn/v2/conf/1689/abstract?type=0':'https://faculty.china-valve.org.cn/v2/conf/1689/abstract?type=0&language=en'
        window.open(url);
      }
    },
    computed:{
      isCN() {
        return this.global.isCN
      }
    }
  }
</script>

<style lang="less" scoped>
.essay-submission-container-pc {
  .content {
    width: 1100px;
    margin: 0 auto;
    .place {
      padding: 20px 0;
      color: #333;
      font-size: 16px;
      border-bottom: 1px solid #dfdfdf;
      a {
        display: inline-block;
        margin: 0 10px;
        color: #333;
      }
    }
    .title {
      text-align: center;
      font-size: 24px;
      margin-top: 30px;
      font-weight: bold;
      .bottom-sol {
        padding-top: 15px;
        height: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        div {
          width: 96px;
          height: 1px;
          color: #106eea;
          border-bottom: solid 2px #106eea;
        }
      }
    }
    .child-content {
      margin-top: 30px;
      .header {
        display: inline-block;
        width: auto;
        vertical-align: top;
        border-style: none solid;
        border-width: 9px;
        border-color: rgba(16, 110, 234, 0.05) transparent rgba(16, 110, 234, 0.05) #106eea;
        background-color: rgba(16, 110, 234, 0.05);
        color: #106eea;
        min-width: 10%;
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
        div {
          line-height: 54px;
          padding: 0 20px;
          margin-right: 10px;
        }
      }
      .child-child-content {
        width: 100%;
        vertical-align: top;
        border-left: 1px solid #106eea;
        border-bottom-left-radius: 0;
        font-size: 14px;
        color: #5E5C5C;
        padding-right: 18px;
        padding-left: 18px;
        line-height: 2;
        letter-spacing: 0;
        .desc {
          padding-top: 15px;
          span {
            font-weight: bold;
            color: #106eea;
          }
        }
        .child-child-table {
          padding-top: 10px;
          .table-desc {
            font-weight: bold;
          }
          table {
            text-align: center;
            thead {
              tr {
                background-color: rgba(16, 110, 234, 0.05);
                th {
                  background-color: rgba(16, 110, 234, 0.05);
                }
              }
            }
          }
        }
        .submission-demand {
          & > div:first-child {
            font-weight: bold;
          }
        }
        .submission-way {
          padding-top: 10px;
          & > div:first-child {
            font-weight: bold;
          }
        }
        .submission-concat {
          padding-top: 20px;
        }
        .submission-submit {
          text-align: center;
          padding: 50px 0 30px 0;
        }
      }
    }
  }
}
.essay-submission-container-mobile {
  .scrolled-offset {
    margin-top: 50px;
  }
  #header {
    height: 50px;
    /* background-color: #1015a3; */
    background-image: linear-gradient(to right, #0545b5, #000c60);
    background-color: #fff;
    box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
  }
  #header .navbar .mobile-nav-toggle {
    color: #fff;
    /* color: #193db3; */
  }
  .lang-check {
    color: #193db3;
    background-color: #fff;
    /* border: 1px solid #193db3; */
    border-radius: 4px;
    font-size: 14px;
    line-height: 28px;
    text-align: center;
    width: 78px;
    margin-right: 20px;
    margin-left: 80px;
    font-weight: 700;
  }

  .banner h1 {
    position: relative;
    z-index: 1;
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    color: #222222;
    font-family: "Poppins", sans-serif;
    color: #ffffff;
    background: linear-gradient(
        0deg,
        #ffebb9 0%,
        #ffd867 65.9912109375%,
        #ffeaa7 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .banner .yy {
    width: 100%;
    position: absolute;
    top: 36px;
    left: 0;
    color: transparent;
    font-size: 26px;
    font-weight: 700;
    text-shadow: -3px 5px 5px rgba(0, 0, 0, 0.3), -2px -3px 0 #000;
  }

  .banner h2 {
    color: #555555;
    margin: 20px 0 5px 0;
    font-size: 24px;
    font-weight: 400;
    color: #ffffff;
  }
  .banner .logo img {
    width: 100px;
  }
  #hero .box {
    /* border-top: 1px solid #2c48c8;
      border-bottom: 1px solid #2c48c8; */
  }
  #hero .img-list {
    display: flex;
    align-items: center;
    overflow-y: hidden;
    flex-wrap: nowrap;
  }

  #hero .img-list .img-box {
    border: 1px solid #2c48c8;
    margin: 0 5px;
    list-style: none;
    white-space: nowrap;
    width: 45vw;
    padding: 2vw;
  }
  #hero .img-list img {
    width: 41vw;
  }
  .content {
    width: 100%;
    padding: 0 10px;
    .place {
      padding: 20px 0;
      color: #333;
      font-size: 16px;
      border-bottom: 1px solid #dfdfdf;
      a {
        display: inline-block;
        margin: 0 10px;
        color: #333;
      }
    }
    .title {
      text-align: center;
      font-size: 24px;
      margin-top: 30px;
      font-weight: bold;
      .bottom-sol {
        padding-top: 15px;
        height: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        div {
          width: 96px;
          height: 1px;
          color: #106eea;
          border-bottom: solid 2px #106eea;
        }
      }
    }
    .child-content {
      margin-top: 30px;
      .header {
        display: inline-block;
        width: auto;
        vertical-align: top;
        border-style: none solid;
        border-width: 9px;
        border-color: rgba(16, 110, 234, 0.05) transparent rgba(16, 110, 234, 0.05) #106eea;
        background-color: rgba(16, 110, 234, 0.05);
        color: #106eea;
        min-width: 10%;
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
        div {
          line-height: 54px;
          padding: 0 20px;
          margin-right: 10px;
        }
      }
      .child-child-content {
        width: 100%;
        vertical-align: top;
        border-left: 1px solid #106eea;
        border-bottom-left-radius: 0;
        font-size: 14px;
        color: #5E5C5C;
        padding-right: 18px;
        padding-left: 18px;
        line-height: 2;
        letter-spacing: 0;
        .desc {
          padding-top: 15px;
          span {
            font-weight: bold;
            color: #106eea;
          }
        }
        .child-child-table {
          padding-top: 10px;
          .table-desc {
            font-weight: bold;
          }
          table {
            text-align: center;
            thead {
              tr {
                background-color: rgba(16, 110, 234, 0.05);
                th {
                  background-color: rgba(16, 110, 234, 0.05);
                }
              }
            }
          }
        }
        .submission-demand {
          & > div:first-child {
            font-weight: bold;
          }
        }
        .submission-way {
          padding-top: 10px;
          & > div:first-child {
            font-weight: bold;
          }
        }
        .submission-concat {
          padding-top: 20px;
        }
        .submission-submit {
          text-align: center;
          padding: 50px 0 30px 0;
        }
      }
    }
  }
}
</style>
